import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Box, Typography} from '@mui/material';
import RoleListViewPage from '../../plugins/RoleManagmentPlugin/pages/role-listview.page';
import PermissionListViewPage from '../../plugins/PermissionManagmentPlugin/pages/permission-listview.page';
import AccessControlPage from '../../plugins/AccessControlPlugin/pages/access-control.page';
import { permissions } from '../components/common/variables/static_variables';
import { useGuard } from '../../plugins/RBACPlugin';

const RBACScreen = () => {

    const [user, setUser] = useState(null);

    const {hasPermission} = useGuard();
    
    useEffect(() => {
      
    }, []);
    
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;
        
        return (
            <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            >
            {value === index && (
                <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
                </Box>
            )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };
    
    function a11yProps(index) {
        return {
            id: `vertical-tab-${index}`,
            'aria-controls': `vertical-tabpanel-${index}`,
        };
    }

    const tabs = [
        {
            label: "Roles",
            requiredPermission: permissions.rbac.ROLE_MANAGEMENT,
        },
        {
            label: "Permission",
            requiredPermission: permissions.rbac.PERMISSION_MANAGEMENT,
        },
        {
            label: "Access Control",
            requiredPermission: permissions.rbac.ACCESS_MANAGEMENT,
        },
    ].filter((item) => hasPermission(item.requiredPermission))

    const tab_panels = [
        {
            component: <RoleListViewPage/>,
            requiredPermission: permissions.rbac.ROLE_MANAGEMENT,
        },
        {
            component: <PermissionListViewPage/>,
            requiredPermission: permissions.rbac.PERMISSION_MANAGEMENT,
        },
        {
            component: <AccessControlPage/>,
            requiredPermission: permissions.rbac.ACCESS_MANAGEMENT,
        },
    ].filter((item) => hasPermission(item.requiredPermission))

    return (
        <div>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs">
                    {
                        tabs.map((item, i) => (
                            <Tab label={item.label} {...a11yProps(i)} />
                        ))
                    }
                    {/* <Tab label="Roles" {...a11yProps(0)} />
                    <Tab label="Permission"  {...a11yProps(1)} />
                    <Tab label="Access Control" {...a11yProps(2)} /> */}
                </Tabs>
                {
                    tab_panels.map((item, i) => (
                        <TabPanel value={value} index={i}>
                            {item.component}
                        </TabPanel>
                    ))
                }
                {/* <TabPanel value={value} index={0}>
                    <RoleListViewPage/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <PermissionListViewPage/>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <AccessControlPage />
                </TabPanel> */}
            </Box>
        </div>
    )
}

export default RBACScreen